import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const isValid = control.value.trim().length === control.value.length;
  return isValid ? null : { whitespace: true };
}
